import Vue from 'vue'
import Router from 'vue-router'
// import dashboardComponent from '@/components/Dashboard'
// import taskmanagerComponent from '@/components/Taskmanager'
import wrapperComponent from '@/components/shared/Wrapper'
import AuthGuard from './auth-guard'

const Home = () => import('@/components/Home')
const Profile = () => import('@/components/user/Profile')
const Signup = () => import('@/components/user/Signup')
const Signin = () => import('@/components/user/Signin')

Vue.use(Router)

// router
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Home,
      meta: {
        title: route => 'Agendakit ' + route.name
      }
    },
    {
      path: '/signup',
      component: Signup,
      meta: {
        title: route => 'Agendakit ' + route.name
      }
    },
    {
      path: '/signin',
      component: Signin,
      meta: {
        title: route => 'Agendakit ' + route.name
      }
    },
    {
      name: 'Profile',
      path: '/profile',
      component: Profile,
      beforeEnter: AuthGuard,
      meta: {
        title: route => 'Agendakit ' + route.name,
        addToTabs: true
      }
    },
    {
      name: 'Dashboard',
      path: '/dashboard/:viewName',
      props: true,
      component: wrapperComponent,
      beforeEnter: AuthGuard,
      meta: {
        title: route => route.name + ' ' + route.params.viewName,
        addToTabs: true
      }
    },
    {
      name: 'Taskmanager',
      path: '/taskmanager',
      props: route => (route.query || {}),
      component: wrapperComponent,
      beforeEnter: AuthGuard,
      meta: {
        title: route => route.query.topParentName,
        addToTabs: true
      }
    },
    {
      name: 'Reports', // dup, props viewName must match components props: ['viewName'],
      path: '/reports/:viewName',
      props: true,
      component: wrapperComponent,
      beforeEnter: AuthGuard,
      meta: {
        title: route => route.name + ' ' + route.params.viewName,
        addToTabs: true
      }
    },
    {
      name: 'Contact',
      // dup, props viewName must match components props: ['viewName'],
      path: '/contacts/:viewName',
      props: true,
      component: wrapperComponent,
      beforeEnter: AuthGuard,
      meta: {
        title: route => route.name + ' ' + route.params.viewName,
        addToTabs: true
      }
    },
    {
      name: 'Property',
      // dup, props viewName must match components props: ['viewName'],
      path: '/properties/:viewName',
      props: true,
      component: wrapperComponent,
      beforeEnter: AuthGuard,
      meta: {
        title: route => route.name + ' ' + route.params.viewName,
        addToTabs: true
      }
    },
    {
      path: '/redirect/:path*',
      component: () => import('@/views/redirect/index')
    }
  ]
})
